import { GlowBar } from './glow-bar.tsx'

const NavigationSelectIndicator = () => (
  <div className="absolute -left-2 top-1/2 flex h-[30px] -translate-y-2/4 items-center">
    <GlowBar />
  </div>
)

export { NavigationSelectIndicator }
